import * as React from "react";
import { CircularProgress } from "@mui/material";
import Center from "./Center";

export default function CustomCircularProgress({ color = "#1981F3" }) {
  return (
    <Center>
      <CircularProgress sx={{ color }} />
    </Center>
  );
}
